// extracted by mini-css-extract-plugin
export default {"mainContainer":"ResetPassword_mainContainer__UB5dz","mainHeading":"ResetPassword_mainHeading__NVPfw"};